import StatsIcon from './components/StatsIcon';
import StatsItem from './components/StatsItem';
import StatsLabel from './components/StatsLabel';
import StatsNumber from './components/StatsNumber';
import StatsSeparator from './components/StatsSeparator';

import cn from '../../utils/cn';

export interface StatsProps {
  children: React.ReactNode;
  className?: string;
}

const Stats = ({ children, className }: StatsProps) => {
  return (
    <div className={cn('flex flex-wrap gap-2 animate-in', className)}>
      {children}
    </div>
  );
};

Stats.Item = StatsItem;
Stats.Icon = StatsIcon;
Stats.Number = StatsNumber;
Stats.Label = StatsLabel;
Stats.Separator = StatsSeparator;

export default Stats;
